import React, { useCallback, useState } from 'react';
import { Dropdown, DropdownItem } from '../Dropdown';
import { dueDateItems, menuItems } from '../../helpers/list';
import AssignPopupV2 from '../dropdowns/assignPopup/assignPopupV2';
import { statusItems } from '../../global/constants';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { isEmpty } from '../../helpers/common';
interface FilterDropdownsProps {
  onChangeStatus: (type: number) => void;
  onChangePriority: (type: number) => void;
  onChangeProject: (id: string) => void;
  onChangeDueDate: (date: string) => void;
}
const FilterDropdowns: React.FC<FilterDropdownsProps> = (props: FilterDropdownsProps) => {
  const { onChangeStatus, onChangePriority, onChangeProject, onChangeDueDate } = props;
  const { viewStore, workspaceStore, projectStore } = rootStore;
  const { createViewInput } = viewStore;
  const { currentWorkspace } = workspaceStore;
  const { projects } = projectStore;
  //State variables
  const [searchProject, setSearchProject] = useState(projects);

  const handleProjectSearch = useCallback(
    (value: string) => {
      if (isEmpty(value)) return projects;
      const searchNewText = value.trim().toLowerCase();
      const words = searchNewText.split(' ').filter((word) => word.length > 0);
      const updatedList = projects?.filter((item) => {
        const title = item?.name.trim().toLowerCase() || '';
        return words.some((word) => title.includes(word));
      });
      setSearchProject(updatedList);
    },
    [projects]
  );

  return (
    <>
      <Dropdown
        content={<DropdownItem label='Status' iconName='status-icon' iconSize={16} iconTone='stroke' />}
        trigger='hover'
        isMinWidth={150}>
        {statusItems.map((item) => {
          const isChecked = createViewInput?.filters.status?.statuses.includes(item.type);
          return (
            <DropdownItem
              key={item.type}
              label={item.label}
              onClick={() => onChangeStatus(item.type)}
              iconName={item.iconName}
              isCheckBox={true}
              isChecked={isChecked}
            />
          );
        })}
      </Dropdown>

      <Dropdown
        content={<DropdownItem label='Priority' iconName='Priority-High-icon' iconSize={16} />}
        trigger='hover'
        isMinWidth={150}>
        {menuItems.map((item, index) => {
          const isChecked = createViewInput?.filters?.priority?.priorities.includes(item.key);
          return (
            <DropdownItem
              key={index}
              label={item.label}
              onClick={() => onChangePriority(item.key)}
              iconName={item.icon}
              isCheckBox={true}
              isChecked={isChecked}
            />
          );
        })}
      </Dropdown>
      <AssignPopupV2
        projectUsers={currentWorkspace?.users || []}
        isContextMenu={true}
        isView={true}
        isMultiAssignee={true}
      />

      <Dropdown
        content={<DropdownItem label='Due date' iconName='calendar-icon' iconSize={16} iconViewBox='0 0 18 18' />}
        trigger='hover'
        isMinWidth={150}>
        {dueDateItems.map((item, index) => (
          <DropdownItem key={index} label={item.label} onClick={() => onChangeDueDate(item.label)} />
        ))}
      </Dropdown>

      <Dropdown
        content={<DropdownItem label='Project' iconName='navbar-project-icon' iconSize={16} iconViewBox='0 0 18 18' />}
        trigger='hover'
        isMinWidth={150}
        onChangeSearch={handleProjectSearch}>
        {searchProject?.map((item, index) => {
          const isChecked = createViewInput?.filters?.project?.projects.includes(item.id);
          return (
            <DropdownItem
              key={index}
              label={item.name}
              isCheckBox={true}
              isChecked={isChecked}
              onClick={() => onChangeProject(item.id)}
            />
          );
        })}
      </Dropdown>
    </>
  );
};

export default observer(FilterDropdowns);
